import React from "react";

import FormRenderer from "Common/Custom/FormRenderer";



const PaymentDetails = ({ formdata, values, errors, handleChange, optionConfig, billingRates }) => {

  return (

    <div className="col-12 mt-4 mb-5">

      <div className="card shadow-sm border">

        <div className="card-header border-bottom">

          <h5 className="mb-0 fw-semibold">

            <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2">

              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>

              <line x1="1" y1="10" x2="23" y2="10"></line>

            </svg>

            Payment Details

          </h5>

        </div>

        <div className="card-body p-4">

          {/* Desktop Layout - Side by Side */}

          <div className="row g-4">

            {/* Billing Summary */}

            <div className="col-lg-6 border-end">

              <div className="billing-summary-card bg-light rounded-3 p-4">

                <h6 className="fw-bold mb-4 text-muted">

                  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2">

                    <path d="M9 11l3 3L22 4"></path>

                    <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"></path>

                  </svg>

                  Billing Summary

                </h6>

                <div className="billing-items">

                  <div className="d-flex justify-content-between align-items-center py-2 border-bottom">

                    <span className="text-muted">Booking Charge</span>

                    <span className="fw-bold fs-6">₹{billingRates.bookingCharge || 0}</span>

                  </div>

                  <div className="d-flex justify-content-between align-items-center py-2 border-bottom">

                    <span className="text-muted">Food Charge</span>

                    <span className="fw-bold fs-6">₹{billingRates.foodCharge || 0}</span>

                  </div>

                  <div className="d-flex justify-content-between align-items-center py-3">

                    <span className="fw-bold text-primary fs-5">Total Amount</span>

                    <span className="fw-bold text-primary fs-4">₹{billingRates.total || 0}</span>

                  </div>

                </div>

              </div>

            </div>



            {/* Payment Info */}

            <div className="col-lg-6">

              <h6 className="fw-bold mb-4 text-muted">

                <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2">

                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>

                  <polyline points="14 2 14 8 20 8"></polyline>

                  <line x1="16" y1="13" x2="8" y2="13"></line>

                  <line x1="16" y1="17" x2="8" y2="17"></line>

                  <polyline points="10 9 9 9 8 9"></polyline>

                </svg>

                Payment Information

              </h6>

              <FormRenderer

                fields={formdata.PaymentsDetails}

                values={values}

                errors={errors}

                handleChange={handleChange}

                optionConfig={optionConfig}

              />

            </div>

          </div>

        </div>

      </div>

    </div>

  );

};



export default PaymentDetails;

